export default __webpack_public_path__ + "static/media/hero-pilot-classroom.10a8ef54.jpg";